// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-menu {
    text-align: left;
}
.ant-menu-inline {
    background-color: #ffffff !important;
}
.ant-menu-submenu-selected >.ant-menu-submenu-title {
    color: #000000 !important;
}
.ant-layout-content {
    padding: 0 !important;
}

.payapt-menu-item-selected, .payapt-menu-item {
    height: 40px;
    font-family: 'Inter' !important;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--black-text) !important;
    padding-left: 24px !important;
    align-items: center;
    /* display: flex; */
    margin-left: 0px !important;
    margin-right: 0px !important;
    /* padding-right: 0px !important; */
    width: 100% !important;
    margin-top: 10px;
    margin-bottom: 10px;

}
.payapt-menu-item-selected {
    background-color: var(--menu-item-background) !important;
    font-weight: 600;
    border-radius: 0 !important;
    border-left: 4px solid var(--primary-color);
    padding-left: 19px !important;
    margin: 0px !important;
    /* padding-right: 0px !important; */
}
.menu-item-text {
    margin-left: 15px;
    text-align: left;
}
.payapt-menu-container {
    width: 100% !important;
    border-inline-end: none !important;
}
.payapt-menu-container-collapse {
    width: 100% !important;
    border-inline-end: none !important;
}
.payapt-submenu-item-selected, .payapt-submenu-item {
    min-height: 40px;
    font-family: 'Inter' !important;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--black-text) !important;
    align-items: center;
    /* display: flex; */
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-right: 0px !important;
    margin: 0px !important;
    width: 100% !important;

}
.payapt-submenu-item-selected > .ant-menu-submenu-title {
    background-color: var(--menu-item-background) !important;
    font-weight: 600;
    border-radius: 0 !important;
    border-left: 4px solid var(--primary-color);
    margin: 0px !important;
    padding-right: 0px !important;
    width: 100%;
}
.payapt-submenu-item-selected {
    margin: 0px !important;
    padding-right: 0px !important;
}
.payapt-nested-menu-item {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-transform: capitalize;
    color: var(--text-color);
    width: 100%;
}
.payapt-nested-menu-item-selected {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    text-transform: capitalize;
    color: var(--primary-color) !important;
    /* background-color: #ffffff !important; */
    background: #F7F9F8 !important;
    width: 100% !important;
    padding-right: 0 !important;
    margin-right: 0 !important;
    border-radius: 0 !important;
    padding-left: 52px !important;
    margin-left: 0 !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/styles/menu.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,mCAAmC;IACnC,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,mCAAmC;IACnC,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;;AAEvB;AACA;IACI,wDAAwD;IACxD,gBAAgB;IAChB,2BAA2B;IAC3B,2CAA2C;IAC3C,6BAA6B;IAC7B,sBAAsB;IACtB,mCAAmC;AACvC;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,kCAAkC;AACtC;AACA;IACI,sBAAsB;IACtB,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,mCAAmC;IACnC,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;IACtB,sBAAsB;;AAE1B;AACA;IACI,wDAAwD;IACxD,gBAAgB;IAChB,2BAA2B;IAC3B,2CAA2C;IAC3C,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,wBAAwB;IACxB,WAAW;AACf;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,sCAAsC;IACtC,0CAA0C;IAC1C,8BAA8B;IAC9B,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;AAC7B","sourcesContent":[".ant-menu {\n    text-align: left;\n}\n.ant-menu-inline {\n    background-color: #ffffff !important;\n}\n.ant-menu-submenu-selected >.ant-menu-submenu-title {\n    color: #000000 !important;\n}\n.ant-layout-content {\n    padding: 0 !important;\n}\n\n.payapt-menu-item-selected, .payapt-menu-item {\n    height: 40px;\n    font-family: 'Inter' !important;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: capitalize;\n    color: var(--black-text) !important;\n    padding-left: 24px !important;\n    align-items: center;\n    /* display: flex; */\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n    /* padding-right: 0px !important; */\n    width: 100% !important;\n    margin-top: 10px;\n    margin-bottom: 10px;\n\n}\n.payapt-menu-item-selected {\n    background-color: var(--menu-item-background) !important;\n    font-weight: 600;\n    border-radius: 0 !important;\n    border-left: 4px solid var(--primary-color);\n    padding-left: 19px !important;\n    margin: 0px !important;\n    /* padding-right: 0px !important; */\n}\n.menu-item-text {\n    margin-left: 15px;\n    text-align: left;\n}\n.payapt-menu-container {\n    width: 100% !important;\n    border-inline-end: none !important;\n}\n.payapt-menu-container-collapse {\n    width: 100% !important;\n    border-inline-end: none !important;\n}\n.payapt-submenu-item-selected, .payapt-submenu-item {\n    min-height: 40px;\n    font-family: 'Inter' !important;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: capitalize;\n    color: var(--black-text) !important;\n    align-items: center;\n    /* display: flex; */\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n    padding-right: 0px !important;\n    margin: 0px !important;\n    width: 100% !important;\n\n}\n.payapt-submenu-item-selected > .ant-menu-submenu-title {\n    background-color: var(--menu-item-background) !important;\n    font-weight: 600;\n    border-radius: 0 !important;\n    border-left: 4px solid var(--primary-color);\n    margin: 0px !important;\n    padding-right: 0px !important;\n    width: 100%;\n}\n.payapt-submenu-item-selected {\n    margin: 0px !important;\n    padding-right: 0px !important;\n}\n.payapt-nested-menu-item {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    text-transform: capitalize;\n    color: var(--text-color);\n    width: 100%;\n}\n.payapt-nested-menu-item-selected {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 15px;\n    text-transform: capitalize;\n    color: var(--primary-color) !important;\n    /* background-color: #ffffff !important; */\n    background: #F7F9F8 !important;\n    width: 100% !important;\n    padding-right: 0 !important;\n    margin-right: 0 !important;\n    border-radius: 0 !important;\n    padding-left: 52px !important;\n    margin-left: 0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
